var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.displayTranscription
    ? _c("div", [
        _c(
          "a",
          {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip.left",
                value: "View Transcription",
                expression: "'View Transcription'",
                modifiers: { left: true }
              }
            ],
            staticClass: "transcription-cell__btn",
            attrs: {
              href: "javascript:;",
              "data-testid": "v2-reporting-transcription-btn"
            },
            on: { click: _vm.openTranscription }
          },
          [_c("i", { staticClass: "fa fa-file-text-o" })]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }